import React from 'react';
import { Box, Heading, List, ListItem } from '@chakra-ui/react';

// Same size as the Profile Summary and Experience body text on the public page.
export const BODY_TEXT_SIZE = '14px';

// Space above and below the divider, so it sits midway between the role title and the
// Key Skills heading.
export const DIVIDER_SPACING = 8;

// Print: smaller text and tighter pills; screen styles are unchanged.
export const PRINT_PILL_STYLES = {
  breakInside: 'avoid',
  fontSize: '9pt',
  paddingTop: '2pt',
  paddingBottom: '2pt',
  paddingLeft: '7pt',
  paddingRight: '7pt'
};

// Key Skills block for the public sharing page's blue column: a divider, an uppercase
// heading and the skills as outlined pills (still a list for screen readers). With no
// skills, only the divider is shown and the space below it stays blank.
// skills: [{ id, label }] in display order.
const KeySkills = ({ skills, headingFont }) => {
  const hasSkills = skills.length > 0;
  return (
    <Box
      mt={DIVIDER_SPACING}
      pt={hasSkills ? DIVIDER_SPACING : 0}
      borderTopWidth="1px"
      borderTopColor="whiteAlpha.500"
      data-testid="key-skills-divider"
    >
      {hasSkills && (
        <>
          <Heading
            as="h2"
            fontFamily={headingFont}
            fontSize="15px"
            fontWeight="700"
            lineHeight="1.2"
            letterSpacing="0.12em"
            textTransform="uppercase"
            mb={5}
          >
            Key Skills
          </Heading>
          <List as="ul" styleType="none" display="flex" flexWrap="wrap" gap={3} m={0} p={0}>
            {skills.map((skill) => (
              <ListItem
                key={skill.id}
                px={5}
                py={2}
                borderWidth="1px"
                borderColor="whiteAlpha.600"
                borderRadius="full"
                fontSize={BODY_TEXT_SIZE}
                lineHeight="1.3"
                sx={{ '@media print': PRINT_PILL_STYLES }}
              >
                {skill.label}
              </ListItem>
            ))}
          </List>
        </>
      )}
    </Box>
  );
};

export default KeySkills;
